import React, { useState, useEffect, Fragment } from 'react'
import { useNavigate } from 'react-router-dom'

import Script from 'dangerous-html/react'
import PropTypes from 'prop-types'
import carpenterImage from '../assets/carpenter.jpg'
import plumberImage from '../assets/plumber.jpg'
import farmerImage from '../assets/farmer.jpg'
import blacksmithImage from '../assets/blacksmith.jpg'
import constructionWorkerImage from '../assets/construction-worker.jpg'
import electricianImage from '../assets/electrician.jpg'
import gardenerImage from '../assets/gardener.jpg'
import janitorImage from '../assets/janitor.jpg'
import masonImage from '../assets/mason.jpg'
import mechanicImage from '../assets/mechanic.jpg'
import painterImage from '../assets/painter.jpg'
import securityImage from '../assets/security.jpg'
import tailorImage from '../assets/tailor.jpg'
import truckdriverImage from '../assets/truck-driver.jpg'
import welderImage from '../assets/welder.jpg'

import './hero17.css'
import BlurText from './BlurText'
import AnimatedContent from './AnimatedContent'

const Hero17 = (props) => {
  const [userRole, setUserRole] = useState(null);
  
  useEffect(() => {
    const role = sessionStorage.getItem('userRole');
    setUserRole(role);
  }, []);

  const navigate = useNavigate()
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated') === 'true'
    console.log('Auth status:', authStatus); 
    setIsAuthenticated(authStatus)
  }, [])

  const handleAnimationComplete = () => {
    console.log('Animation completed!');
  };
  
  return (
    <div className="hero17-header78">
      <div className="hero17-column thq-section-max-width thq-section-padding">
        <div className="hero17-content1">
          <h1 className="hero17-text1 thq-heading-1">
            {props.heading1 ?? (
              <BlurText
                text="Welcome to our Platform!"
                delay={150}
                animateBy="words"
                direction="top"
                onAnimationComplete={handleAnimationComplete}
                className="text-2xl mb-8"
              />
            )}
          </h1>
          <p className="hero17-text2 thq-body-large">
            {props.content1 ?? (
              <AnimatedContent
              distance={150}
              direction="vertical"
              reverse={false}
              config={{ tension: 80, friction: 25 }}
              initialOpacity={0}
              animateOpacity={true}
              scale={1.1}
              threshold={0.4}
            >
              <div>Find your dream job with us. Explore thousands of job
              opportunities from top companies.</div>
            </AnimatedContent>
            )}
          </p>
        </div>
        {isAuthenticated &&(
          <div className="hero17-actions">
          <button className="btn-hero">
            <span className="thq-body-small">
              {props.action1 ?? (
                <Link to="/" className="nav-link">
                    <span className="home-text114">Switch Role</span>
                </Link>
              )}
            </span>
          </button>
          <button className="btn-hero">
            <span className="thq-body-small">
              {props.action2 ?? (
                <Link to="/" className="nav-link">
                    <span className="home-text114">Switch Role</span>
                </Link>
              )}
            </span>
          </button>
        </div>
        )}
      </div>
      {userRole === 'Labour' && (<div className="hero17-content2">
        <div className="hero17-row-container1 thq-mask-image-horizontal thq-animated-group-container-horizontal">
          <div className="thq-animated-group-horizontal">
            <img
              alt={props.image1Alt}
              src={carpenterImage}
              className="hero17-placeholder-image10 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image2Alt}
              src={plumberImage}
              className="hero17-placeholder-image11 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image3Alt}
              src={farmerImage}
              className="hero17-placeholder-image12 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image4Alt}
              src={blacksmithImage}
              className="hero17-placeholder-image13 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image5Alt}
              src={constructionWorkerImage}
              className="hero17-placeholder-image14 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image6Alt}
              src={electricianImage}
              className="hero17-placeholder-image15 thq-img-ratio-1-1 thq-img-scale"
            />
          </div>
          <div className="thq-animated-group-horizontal">
            <img
              alt={props.image1Alt}
              src={gardenerImage}
              className="hero17-placeholder-image16 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image2Alt}
              src={janitorImage}
              className="hero17-placeholder-image17 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image3Alt}
              src={masonImage}
              className="hero17-placeholder-image18 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image4Alt}
              src={mechanicImage}
              className="hero17-placeholder-image19 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image5Alt}
              src={painterImage}
              className="hero17-placeholder-image20 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt="Hero Image"
              src={securityImage}
              className="hero17-placeholder-image21 thq-img-ratio-1-1 thq-img-scale"
            />
          </div>
        </div>
        <div className="hero17-row-container2 thq-mask-image-horizontal thq-animated-group-container-horizontal">
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={props.image7Alt}
              src={gardenerImage}
              className="hero17-placeholder-image22 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image8Alt}
              src={janitorImage}
              className="hero17-placeholder-image23 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image9Alt}
              src={masonImage}
              className="hero17-placeholder-image24 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image10Alt}
              src={mechanicImage}
              className="hero17-placeholder-image25 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image11Alt}
              src={painterImage}
              className="hero17-placeholder-image26 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image12Alt}
              src={securityImage}
              className="hero17-placeholder-image27 thq-img-ratio-1-1 thq-img-scale"
            />
          </div>
          <div className="thq-animated-group-horizontal-reverse">
            <img
              alt={props.image7Alt}
              src={tailorImage}
              className="hero17-placeholder-image28 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image8Alt}
              src={truckdriverImage}
              className="hero17-placeholder-image29 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image9Alt}
              src={welderImage}
              className="hero17-placeholder-image30 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image10Alt}
              src={carpenterImage}
              className="hero17-placeholder-image31 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt={props.image11Alt}
              src={blacksmithImage}
              className="hero17-placeholder-image32 thq-img-ratio-1-1 thq-img-scale"
            />
            <img
              alt="Hero Image"
              src={constructionWorkerImage}
              className="hero17-placeholder-image33 thq-img-ratio-1-1 thq-img-scale"
            />
          </div>
        </div>
      </div>
    )}
      <div>
        <div className="hero17-container2">
          <Script
            html={`<style>
  @keyframes scroll-x {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(calc(-100% - 16px));
    }
  }

  @keyframes scroll-y {
    from {
      transform: translateY(0);
    }
    to {
      transform: translateY(calc(-100% - 16px));
    }
  }
</style>
`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

Hero17.defaultProps = {
  image1Src:
    '',
  image2Src:
    'https://images.unsplash.com/photo-1570989614585-581ee5f7e165?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1Nnw&ixlib=rb-4.0.3&q=80&w=1080',
  image6Src:
    'https://images.unsplash.com/photo-1610986602726-19f650133f7a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1N3w&ixlib=rb-4.0.3&q=80&w=1080',
  content1: undefined,
  image8Src:
    'https://images.unsplash.com/photo-1565383690591-1ee1b6582cef?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1OHw&ixlib=rb-4.0.3&q=80&w=1080',
  image10Alt: 'Hero Image',
  image10Src:
    'https://images.unsplash.com/photo-1697089843672-eece9d6a7848?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1OXw&ixlib=rb-4.0.3&q=80&w=1080',
  image11Alt: 'Hero Image',
  image3Src:
    'https://images.unsplash.com/photo-1653669486830-f55a084b5ea9?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1NXw&ixlib=rb-4.0.3&q=80&w=1080',
  image4Src:
    'https://images.unsplash.com/photo-1630091790659-85ec55570e0b?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1OXw&ixlib=rb-4.0.3&q=80&w=1080',
  image5Src:
    'https://images.unsplash.com/photo-1494093631376-4fac63328133?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1OXw&ixlib=rb-4.0.3&q=80&w=1080',
  image2Alt: 'Hero Image',
  image12Alt: 'Hero Image',
  image8Alt: 'Hero Image',
  image4Alt: 'Hero Image',
  action1: undefined,
  heading1: undefined,
  image11Src:
    'https://images.unsplash.com/photo-1594391575588-3f2f3245e1ab?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1N3w&ixlib=rb-4.0.3&q=80&w=1080',
  image12Src:
    'https://images.unsplash.com/photo-1726569058494-a8e6ddcf1799?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1OHw&ixlib=rb-4.0.3&q=80&w=1080',
  image3Alt: 'Hero Image',
  image9Src:
    'https://images.unsplash.com/photo-1653669486900-fd06730dcc78?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1OHw&ixlib=rb-4.0.3&q=80&w=1080',
  image6Alt: 'Hero Image',
  action2: undefined,
  image7Src:
    'https://images.unsplash.com/photo-1526375664441-d2431a6d501c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8cmFuZG9tfHx8fHx8fHx8MTczNzMyNjg1N3w&ixlib=rb-4.0.3&q=80&w=1080',
  image5Alt: 'Hero Image',
  image1Alt: 'Job Portal Image',
  image9Alt: 'Hero Image',
  image7Alt: 'Hero Image',
}

Hero17.propTypes = {
  image1Src: PropTypes.string,
  image2Src: PropTypes.string,
  image6Src: PropTypes.string,
  content1: PropTypes.element,
  image8Src: PropTypes.string,
  image10Alt: PropTypes.string,
  image10Src: PropTypes.string,
  image11Alt: PropTypes.string,
  image3Src: PropTypes.string,
  image4Src: PropTypes.string,
  image5Src: PropTypes.string,
  image2Alt: PropTypes.string,
  image12Alt: PropTypes.string,
  image8Alt: PropTypes.string,
  image4Alt: PropTypes.string,
  action1: PropTypes.element,
  heading1: PropTypes.element,
  image11Src: PropTypes.string,
  image12Src: PropTypes.string,
  image3Alt: PropTypes.string,
  image9Src: PropTypes.string,
  image6Alt: PropTypes.string,
  action2: PropTypes.element,
  image7Src: PropTypes.string,
  image5Alt: PropTypes.string,
  image1Alt: PropTypes.string,
  image9Alt: PropTypes.string,
  image7Alt: PropTypes.string,
}

export default Hero17
